import { Injectable, OnDestroy, inject } from '@angular/core';
import { CommonIP } from '@model/ftf-api.model';
import { Store } from '@ngrx/store';
import * as HistoryActions from '@store/actions/history.actions';
import { selectHistoryItems } from '@store/selectors/history.selectors';
import { Observable, Subject, takeUntil } from 'rxjs';

import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root',
})
export class HistoryService implements OnDestroy {
  private store = inject(Store);
  private accountService = inject(AccountService);

  private readonly $ngDestroyed = new Subject<void>();
  historyItemsSubject$: Observable<CommonIP[]> = this.store.select(selectHistoryItems);

  constructor() {
    this.accountService.isAccountDetailsLoaded$.pipe(takeUntil(this.$ngDestroyed)).subscribe((isLoaded) => {
      if (isLoaded) {
        this.loadPreviousSearchHistory();
      }
    });
    this.loadPreviousSearchHistory();
  }

  ngOnDestroy() {
    this.$ngDestroyed.next();
    this.$ngDestroyed.complete();
  }

  /**
   * Saves a history object to the user's history history.
   *
   * @param {CommonIP} historyObject - The history object to be saved.
   */
  saveSearchHistory(historyObject: CommonIP) {
    this.store.dispatch(HistoryActions.addHistoryItem({ item: historyObject }));
  }

  /**
   * Loads the previous history for the current user and updates the history items subject.
   */
  loadPreviousSearchHistory() {
    this.store.dispatch(HistoryActions.loadHistory());
  }
}
